import { PUZZLE_TYPES } from './config';

class PuzzleSolver {
  validateBinary(puzzle, attempt) {

    
    if (!Array.isArray(attempt) || !Array.isArray(attempt[0])) {

      return false;
    }

    const size = puzzle.solution.length;
    if (attempt.length !== size || attempt[0].length !== size) {

      return false;
    }

    // First check if all cells are filled
    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        if (attempt[i][j] === null) {

          return false;
        }
      }
    }

    // Check each cell matches solution
    let mismatches = [];
    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        if (attempt[i][j] !== puzzle.solution[i][j]) {
          mismatches.push([i, j]);
        }
      }
    }

    const isValid = mismatches.length === 0;
    

    return isValid;
  }

  validateSolution(puzzle, attempt) {

    
    try {
      if (puzzle.type === PUZZLE_TYPES.BINARY) {
        return this.validateBinary(puzzle, attempt);
      }
      
      console.error('PuzzleSolver: Invalid puzzle type:', puzzle.type);
      return false;
    } catch (error) {
      console.error('PuzzleSolver: Error validating solution:', error);
      return false;
    }
  }

  getBinaryHint(puzzle, attempt) {
    if (!Array.isArray(attempt)) {
      return 'Fill in the empty cells with 0s and 1s';
    }
    
    let correctCells = 0;
    const size = puzzle.solution.length;
    
    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        if (attempt[i][j] === puzzle.solution[i][j]) {
          correctCells++;
        }
      }
    }
    
    return `${correctCells} out of 16 cells are correct`;
  }

  getHint(puzzle, attempt) {

    
    try {
      if (puzzle.type === PUZZLE_TYPES.BINARY) {
        return this.getBinaryHint(puzzle, attempt);
      }
      
      return 'No hint available';
    } catch (error) {
      console.error('PuzzleSolver: Error generating hint:', error);
      return 'Error generating hint';
    }
  }
}

export default PuzzleSolver;